/* eslint-disable react-hooks/exhaustive-deps */
import Link from "next/link";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircleLoading from "../../common/components/CircleLoadding";
import NoDataComponent from "../../common/components/NoData";
import { accountActions } from "../redux/actions";
import { TAccountState } from "../utils/types";

const AccountAnswerInfo = ({ memberHid }) => {
  const dispatch = useDispatch();
  const { extraInfo, isLoadingAchievement } = useSelector((state: { account: TAccountState }) => state.account);
  const handleGetExtraInfo = () => {
    dispatch(accountActions.handleGetExtraInfo(memberHid));
  };

  const directLink = (link) => {
    const postId = link.split("/");
    return postId[postId.length - 1];
  };

  useEffect(() => {
    if (!extraInfo || extraInfo?.memberHid !== memberHid) {
      handleGetExtraInfo();
    }
  }, []);
  return (
    <div>
      {isLoadingAchievement ? (
        <div className="flex justify-center w-full">
          <CircleLoading />
        </div>
      ) : (
        <div>
          {extraInfo?.asks.length === 0 ? (
            <NoDataComponent />
          ) : (
            extraInfo?.asks?.map((item) => (
              <div
                key={item?.post_id}
                className="border p-2 border-gray text-[15px] rounded-md my-3 hover:cursor-pointer w-full text-blackQuiz"
              >
                <Link href={`/hoi-dap/${directLink(item?.direct_link)}`}>
                  <a href={`/hoi-dap/${directLink(item?.direct_link)}`}>
                    <span className="font-semibold">{item?.package_title}</span>
                    <span className="line-clamp-1">{item?.title}</span>
                  </a>
                </Link>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default AccountAnswerInfo;
